import cssVars from '@map/theme/cssVars';
import { MobileTheme } from '@map/theme/types';
import { ThemeColors } from '@map/types';
import { alpha, darken, Direction, lighten } from '@mui/material/styles';
import { deepmerge } from '@mui/utils';
import buildThemeColorsOverride from '@shared/theme/buildThemeColorsOverride';
import { neutralsPalette } from '@shared/theme/colors';
import { buildCommonOverrides } from '@shared/theme/components';
import createMuiTheme from '@shared/theme/createMuiTheme';
import mixins from '@shared/theme/mixins';
import { createVars } from '@shared/theme/predefinedVars';
import { typography } from '@shared/theme/typography';
import { buildOverrides } from './components';

const buildTheme = (direction: Direction, themeColors?: ThemeColors) => {
  const theme = createMuiTheme({
    direction,
    typography,
    palette: {
      action: {
        active: neutralsPalette[700],
        selected: '#e1f5fe',
        disabledBackground: '#afbec5',
      },
      text: {
        primary: neutralsPalette[900],
        secondary: neutralsPalette[700],
      },
      divider: neutralsPalette[400],
    },
    breakpoints: {
      values: {
        xs: 0,
        // xs -> sm: mobile
        sm: 600,
        // sm -> md: tablet
        md: 1025,
        // md -> lg: laptop
        lg: 1919,
        // lg -> xl: desktop
        xl: 9001,
      },
    },
  }) as MobileTheme;

  if (themeColors) {
    theme.palette = deepmerge(theme.palette, buildThemeColorsOverride(themeColors));
  }

  theme.mixins = { ...theme.mixins, ...mixins };

  theme.cssVars = createVars(cssVars);

  const { palette } = theme;

  palette.manipulate = { lighten, darken, fade: alpha };

  theme.components = deepmerge(
    theme.components,
    deepmerge(buildCommonOverrides(theme), buildOverrides(theme)),
  );
  return theme;
};

export default buildTheme;
